import React, {ReactNode, useEffect, useMemo} from 'react';
import {CssTheme} from '@ui/themes/css-theme';
import {
  ThemeSelectorContext,
  useThemeSelector,
} from '@ui/themes/theme-selector-context';
import {applyThemeToDom} from '@ui/themes/utils/apply-theme-to-dom';

interface Props {
  theme: CssTheme | null;
  children: ReactNode;
}

export function CustomAuthThemeProvider({theme, children}: Props) {
  const parentThemeSelector = useThemeSelector();

  useEffect(() => {
    if (!theme) {
      return;
    }

    const previousTheme = parentThemeSelector.selectedTheme;
    applyThemeToDom(normalizeDomTheme(theme));

    return () => {
      applyThemeToDom(normalizeDomTheme(previousTheme));
    };
  }, [parentThemeSelector.selectedTheme, theme]);

  const value = useMemo(() => {
    if (!theme) {
      return parentThemeSelector;
    }

    return {
      allThemes: parentThemeSelector.allThemes.some(item => item.id === theme.id)
        ? parentThemeSelector.allThemes
        : [...parentThemeSelector.allThemes, theme],
      selectedTheme: theme,
      selectTheme: parentThemeSelector.selectTheme,
    };
  }, [parentThemeSelector, theme]);

  return (
    <ThemeSelectorContext.Provider value={value}>
      {children}
    </ThemeSelectorContext.Provider>
  );
}

function normalizeDomTheme(theme: CssTheme): CssTheme {
  return {
    ...theme,
    colors: theme.colors || theme.values || {},
  };
}
